module.exports = __webpack_public_path__ + "img/camper-extension-pricelist.9341436.svg";